import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import withLoading from '../withLoading';


const fetchData = lifecycle({
  componentDidMount() {
    this.props.fetchData().then(() => this.props.setLoading(false));
  },
});

export default compose(
  withState('showLoading', 'setLoading', true),
  fetchData,
  withLoading,
);
